// extracted by mini-css-extract-plugin
export default {"overlay":"modal_overlay__fCMjT","modal":"modal_modal__Nszx8","close":"modal_close__dW+iB"};